<template>
  <div class="warehouse-setting">
    <second-menu-link-content>
      <template v-slot:header>
        <span>仓库管理</span>
      </template>
      <template v-slot:content>
        <div class="warehouse-setting-main">
          <div class="add-warehouse">
            <el-button class="btn-blue" @click="dialogVisible = true"
              >新增</el-button
            >
            <el-dialog
              title="新增仓库"
              :visible.sync="dialogVisible"
              width="400px"
              top="25vh"
            >
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-form-item label="仓库名称：" prop="name">
                  <el-input
                    v-model="ruleForm.name"
                    class="gray"
                    placeholder="请输入仓库名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="仓库id：" prop="erpWarehouseId">
                  <el-input
                    v-model="ruleForm.erpWarehouseId"
                    class="gray"
                    placeholder="请输入仓库id"
                    @input="inputNums(ruleForm.erpWarehouseId,0)"
                  ></el-input>
                </el-form-item>
                <el-form-item label="所在区域：" prop="address">
                  <el-cascader
                    v-model="ruleForm.address"
                    :options="address"
                    :props="defaultParams"
                    class="gray"
                    placeholder="选择区域"
                    filterable
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址：" prop="detailAddress">
                  <el-input
                    v-model="ruleForm.detailAddress"
                    class="gray"
                    placeholder="请输入详细地址"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button
                    class="btn-white"
                    type="primary"
                    @click="reset('ruleForm')"
                    >取消</el-button
                  >
                  <el-button class="btn-blue" @click="addWarehouse('ruleForm')"
                    >保存</el-button
                  >
                </el-form-item>
              </el-form>
            </el-dialog>
          </div>
          <div class="table">
            <el-table :data="tableData" style="width: 100%" v-loading="loading">
              <el-table-column
                prop="name"
                label="仓库名称"
                width="250"
              ></el-table-column>
              <el-table-column
                prop="erpWarehouseId"
                label="仓库id"
              ></el-table-column>
              <el-table-column prop="address" label="仓库地址">
                <template slot-scope="scope">
                  <span>{{ scope.row.address.area }}</span>
                  <span>{{ scope.row.address.address }}</span>
                </template>
              </el-table-column>
              <el-table-column label="服务范围" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.$index === 0 && page === 1">全国</span>
                  <div class="service" v-else>
                    <span class="areas">{{ scope.row.warehouseScope }}</span>
                    <img
                      src="../../../../assets/inventory/edit.png"
                      @click="selectAddress(scope.$index, scope.row.id)"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="250">
                <template slot-scope="scope">
                  <span v-if="scope.$index === 0 && page === 1"
                    >系统预设，不可操作</span
                  >
                  <div v-else>
                    <el-button
                      class="btn-text"
                      type="text"
                      @click="change(scope.row, scope.$index)"
                      >修改</el-button
                    >
                    <el-button
                      class="btn-text"
                      type="text"
                      @click.native.prevent="delate(scope.row)"
                      >删除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-dialog
              title="修改仓库"
              :visible.sync="dialogVisible2"
              width="400px"
              top="25vh"
            >
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <el-form
                :model="ruleForm2"
                :rules="rules"
                ref="ruleForm2"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-form-item label="仓库名称：" prop="name">
                  <el-input
                    v-model="ruleForm2.name"
                    class="gray"
                    placeholder="输"
                  ></el-input>
                </el-form-item>
                <el-form-item label="仓库id：" prop="erpWarehouseId">
                  <el-input
                    v-model="ruleForm2.erpWarehouseId"
                    class="gray"
                    @input="inputNums(ruleForm2.erpWarehouseId,1)"
                    placeholder="请输入仓库id"
                  ></el-input>
                </el-form-item>
                <el-form-item label="所在区域：" prop="area">
                  <el-cascader
                    v-model="ruleForm2.area"
                    :options="address"
                    :props="defaultParams"
                    class="gray"
                    placeholder="选择区域"
                    filterable
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址：" prop="address">
                  <el-input
                    v-model="ruleForm2.address"
                    class="gray"
                    placeholder="请输入地址"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button
                    class="btn-white"
                    type="primary"
                    @click="reset('ruleForm2')"
                    >取消</el-button
                  >
                  <el-button class="btn-blue" @click="save('ruleForm2')"
                    >保存</el-button
                  >
                </el-form-item>
              </el-form>
            </el-dialog>
            <div class="table_pagination">
              <PaginationModul
                :total="total"
                :currentPage="page"
                @queryChange="pageChange"
              ></PaginationModul>
            </div>
          </div>
        </div>
        <el-dialog title="地址选择" :visible.sync="showAddressSelector">
          <selector-address
            :allAddressList="allAddressList"
            :selectedAddressList="selectedAddressList"
            @saveAddress="onSaveAddress"
          ></selector-address>
        </el-dialog>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationModul from "base/PaginationTpl";
import DBInventory from "models/db/inventory.js";
import DBAddress from "models/db/address.js";
import SelectorAddress from "base/SelectorAddress";
const dbInventory = new DBInventory();
const dbAddress = new DBAddress();
export default {
  data() {
    return {
      tableData: [], // 表格数据存放
      ruleForm: {
        name: "",
        address: [],
        detailAddress: "",
        erpWarehouseId: null
      }, // 添加表单
      ruleForm2: {}, // 修改表单
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        address: [{ required: true, message: "请选择区域", trigger: "change" }],
        area: [{ required: true, message: "请选择区域", trigger: "change" }],
        detailAddress: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
      },
      address: [] /* 地址列表 */,
      defaultParams: {
        label: "name",
        value: "id",
        children: "children",
      }, // 联级格式
      dialogVisible: false, // 弹框1
      dialogVisible2: false, // 弹框2
      index: "",
      total: 0, // 条目总数
      page: 1, // 当前页数
      loading: true,
      showAddressSelector: false,
      // 城市列表数据
      allAddressList: [],
      // 被默认选中的地址列表
      selectedAddressList: [],
      tableIndex: "",
      regionsList: [], // 地址选中的id列表
      warehouseId: "",
    };
  },
  components: {
    SecondMenuLinkContent,
    SelectorAddress,
    PaginationModul,
  },
  beforeMount() {
    this.getWarehouse();
    this.getAddress();
  },
  methods: {
    /* 限制数量为正整数和0 */
    inputNums(val, type) {
      let num = val.toString().match(/^\d*/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^\d*/g)[0]
        : "";
      if (type) {
        this.ruleForm2.erpWarehouseId = num;
      } else {
        this.ruleForm.erpWarehouseId = num;
      }
    },
    // 获取仓库数据
    getWarehouse() {
      let currentPage = this.page;
      dbInventory.getDBWarehouse(currentPage).then((res) => {
        if (res.success) {
          this.total = res.result.totalNum;
          let arr = [];
          res.result.items.map((value, index, array) => {
            let obj = {};
            obj.name = value.name;
            obj.id = value.id;
            if (value.erpWarehouseId) {
              obj.erpWarehouseId = value.erpWarehouseId;
            } else {
              obj.erpWarehouseId = '';
            }
            obj.warehouseScope = value.warehouseScope;
            obj.address = { area: value.area, address: value.address };
            let area = [value.province];
            if (value.city) {
              area.push(value.city);
              if (value.regions) {
                area.push(value.regions);
              }
            }
            obj.area = area;
            arr.push(obj);
          });
          this.loading = false;
          this.tableData = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取地址信息
    getAddress() {
      dbAddress.getDBAddressMock().then((res) => {
        this.address = res;
        this.allAddressList = res;
      });
    },
    // 取消、清空、关闭弹框
    reset(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.dialogVisible2 = false;
    },
    // 添加仓库
    addWarehouse(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let name = this.ruleForm.name;
          let erpWarehouseId = Number(this.ruleForm.erpWarehouseId);
          let province = this.ruleForm.address[0];
          let city = this.ruleForm.address[1] ? this.ruleForm.address[1] : null;
          let regions = this.ruleForm.address[2]
            ? this.ruleForm.address[2]
            : null;
          let address = this.ruleForm.detailAddress;
          dbInventory
            .postDBAddWarehouse(name, province, city, regions, address, erpWarehouseId)
            .then((res) => {
              if (res.success) {
                this.getWarehouse();
                this.$refs[formName].resetFields();
                this.dialogVisible = false;
              } else {
                this.$message.error(res.message);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 新增服务范围
    selectAddress(index, id) {
      this.tableIndex = index;
      this.warehouseId = id;
      this.selectedAddressList = [];
      let warehouseId = this.warehouseId
      dbInventory.getDBService(warehouseId).then(res => {
        if (res.success) {
          res.result.res.map(value => {
            let obj = {}
            obj.id = value
            this.selectedAddressList.push(obj)
          })
          let exist = []
          exist = this.allAddressList
          exist.map(item => {
            item.disabled = false
            item.children.map(val => {
              val.disabled = false
              val.children.map(v => {
                v.disabled = false
              })
            })
          })
          this.$nextTick(() => {
            res.result.exist.map(item => {
              exist.map(val => {
                if (item == val.id) {
                  // val.disabled = true
                  this.$set(val,"disabled",true)
                }
                val.children.map(v => {
                  if (item == v.id) {
                    // v.disabled = true
                  this.$set(v,"disabled",true)
                  }
                  v.children.map(t => {
                    if (item == t.id) {
                      // t.disabled = true
                  this.$set(t,"disabled",true)
                    }
                  })
                })
              })
            })
            this.allAddressList = exist
          })
        } else {
          this.$message.error(res.message);
        }
      })
      this.showAddressSelector = true;
    },
    onSaveAddress(data) {
      let { selectedAddressList, selectedProOrMun } = data;
      this.regionsList = []
      selectedAddressList.map((value) => {
        this.regionsList.push(value.id);
      });
      console.log("选择的", selectedProOrMun);
      selectedProOrMun = [];
      this.allAddressList.map((item) => {
        selectedAddressList.map((s) => {
          if (s.grandParentId === item.id) {
            item.children.map((value) => {
              value.children.map((v) => {
                if (s.id === v.id) {
                  let address = `${item.name}${value.name}`;
                  selectedProOrMun.push(address);
                }
              });
            });
          }
        });
      });
      let arr = [...new Set(selectedProOrMun)];
      let deliveryArea = "";
      // selectedProOrMun
      for (let i = 0; i < arr.length; i++) {
        if (arr.length !== 1) {
          deliveryArea += i + 1 + "." + arr[i] + "  ";
        } else {
          deliveryArea += i + 1 + "." + arr[i];
        }
      }
      this.tableData[this.tableIndex].deliveryArea = deliveryArea;
      let warehouseId = this.warehouseId;
      let regionsList = this.regionsList;
      let dataObj = {
        warehouseId,
        regionsList,
      };
      dbInventory.postDBAddWareHouseScope(dataObj).then((res) => {
        if (res.success) {
          setTimeout(() => {
            window.location.reload()
          },400)
          this.getWarehouse();
        } else {
          this.$message.error(res.message);
        }
      });
      // 隐藏地址选择器
      this.showAddressSelector = false;
    },
    // 删除
    delate(row) {
      let id = row.id;
      this.$confirm(`是否确认删除该仓库`, "删除仓库", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        dbInventory.getDBDeleteWarehouse(id).then((res) => {
          if (res.success) {
            this.getWarehouse();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 修改仓库
    change(row) {
      this.dialogVisible2 = true;
      this.ruleForm2 = JSON.parse(JSON.stringify(row));
      this.ruleForm2.address = JSON.parse(JSON.stringify(row)).address.address;
      console.log(this.ruleForm2);
    },
    // 保存修改
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm2);
          let id = this.ruleForm2.id;
          let name = this.ruleForm2.name;
          let erpWarehouseId = Number(this.ruleForm2.erpWarehouseId);
          let province = this.ruleForm2.area[0];
          let city = this.ruleForm2.area[1] ? this.ruleForm2.area[1] : null;
          let regions = this.ruleForm2.area[2] ? this.ruleForm2.area[2] : null;
          let address = this.ruleForm2.address;
          dbInventory
            .postDBUpdateWarehouse(id, name, province, city, regions, address, erpWarehouseId)
            .then((res) => {
              if (res.success) {
                this.getWarehouse();
                this.$refs[formName].resetFields();
                this.dialogVisible2 = false;
              } else {
                this.$message.error(res.message);
              }
            });
          // console.log(this.ruleForm2);
          // this.tableData.splice(
          //   this.index,
          //   1,
          //   JSON.parse(JSON.stringify(this.ruleForm2))
          // );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 翻页
    pageChange(data) {
      this.page = data.currentPage;
      this.getWarehouse();
    },
  },
};
</script>

<style lang="scss" scoped>
.warehouse-setting {
  width: 100%;
  height: 100%;
  .warehouse-setting-main {
    letter-spacing: 1px;
    .add-warehouse {
      display: flex;
      align-items: flex-end;
      margin-bottom: 16px;
      .el-button {
        width: 96px;
        margin-right: 8px;
      }
      .tit {
        font-size: 12px;
        color: rgba(145, 147, 152, 1);
        line-height: 20px;
      }
    }
    .table {
      .table_pagination {
        height: 56px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .el-pagination {
          height: 28px;
          padding: 0px;
          display: flex;
        }
      }
      .service {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 20px;
        .areas {
          width: 90%;
          height: 32px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        img {
          line-height: 32px;
          width: 14px;
          height: 14px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.warehouse-setting {
  .warehouse-setting-main {
    .el-dialog {
      border-radius: 4px;
      .el-dialog__header {
        padding: 0 24px;
        line-height: 48px;
        color: #606266;
        font-family: "PingFangSC-Medium";
        letter-spacing: 1px;
        .el-dialog__title {
          font-size: 16px;
          font-weight: 500;
          color: #606266;
        }
        .el-dialog__headerbtn {
          top: 15px;
        }
      }
      .el-dialog__body {
        padding: 0px 24px 24px 24px;
        .border {
          border-bottom: 1px solid #f7f7f7;
          margin-bottom: 16px;
        }
        .el-form {
          .el-form-item:last-child {
            margin-bottom: 0px;
          }
          .el-form-item {
            margin-bottom: 16px;
            .el-form-item__label {
              line-height: 32px;
            }
            .el-form-item__content {
              line-height: 32px;
              .el-cascader {
                width: 252px;
                line-height: 32px;
                .el-input {
                  line-height: 32px;
                  .el-input__inner {
                    height: 32px;
                    background: rgba(234, 238, 245, 0.2);
                    border: 1px solid #eaeef5;
                  }
                }
                .is-focus {
                  .el-input__inner {
                    border: 1px solid rgba(61, 116, 242, 1);
                  }
                }
                .el-input__suffix {
                  height: 40px;
                  top: -3px;
                  right: 0px;
                }
              }
              .el-form-item__error {
                padding-top: 2px;
              }
              .el-button {
                width: 96px;
              }
              .el-button.btn-blue {
                margin-left: 24px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
